import { Fragment } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Btn, Spinner } from 'AbstractElements';
import TransactionCards from 'Component/Learning/Transaction/TransactionCards';
import TransactionFilter from 'Component/Learning/Transaction/Filter/TransactionFilter';
import { exportTransactions } from 'Features/Learning/Transactions/Utils/TransactionUtils';
import { clearExportFile } from 'Features/Learning/Transactions/transactionSlice';

const TransactionContain = () => {
	const cards = useSelector(state => state.Transaction.data.data)
	const filter = useSelector(state => state.Transaction.filters)
	const isLoadingExport = useSelector(state => state.Transaction.isExport)
	const exportFileUrl = useSelector(state => state.Transaction.exportFileUrl)
	const dispatch = useDispatch();

	const handleExport = (e) => {
		e.preventDefault();
		dispatch(exportTransactions(filter));
	}

	const showExportPanel = isLoadingExport || exportFileUrl;

	return (
		<Fragment>
			<Container fluid={true}>
				<Col md="12" className="project-list">
					{cards && (
						<Card>
							<Row className='justify-content-end align-items-center mb-3'>
								<Col className="d-flex justify-content-end">
									<Btn attrBtn={{ color: 'warning', onClick: handleExport, disabled: isLoadingExport }}>
										<i className="fa fa-upload fa-lg"></i> Export Data Transaksi
									</Btn>
								</Col>
							</Row>
						</Card>
					)}
				</Col>
				{showExportPanel && (
					<Col lg="12 mb-5">
						{isLoadingExport && (
							<>
								<div className="loader-box">
									<Spinner attrSpinner={{ className: 'loader-30' }} />
								</div>
								<h6 className="sub-title mb-0 text-center">{'Exporting Data...'}</h6>
								<p className="text-muted text-center mb-0">{'Mohon tunggu, file sedang disiapkan.'}</p>
							</>
						)}
						{exportFileUrl && !isLoadingExport && (
							<div className="text-center">
								<h6 className="sub-title mb-2">{'File export siap'}</h6>
								<p className="text-muted mb-3">{'Klik tombol di bawah untuk mengunduh Excel.'}</p>
								<Btn attrBtn={{
									tag: 'a',
									href: exportFileUrl,
									target: '_blank',
									rel: 'noopener noreferrer',
									color: 'success',
								}}>
									<i className="fa fa-download fa-lg"></i> Download Excel
								</Btn>
								<Btn attrBtn={{
									color: 'light',
									className: 'ms-2',
									onClick: () => dispatch(clearExportFile()),
								}}>
									Tutup
								</Btn>
							</div>
						)}
					</Col>
				)}
				<Row className='learning-block'>
					<Col xl="9" className='xl-80'>
						<Row>
							<TransactionCards />
						</Row>
					</Col>
					{cards && (
						<TransactionFilter />
					)}
				</Row>
			</Container>
		</Fragment>
	);
};
export default TransactionContain;
